import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const GetDraftedAppContext = React.createContext({});
export let getDraftedAppMachine: any;

const MODULE_NAME = 'machines.draftedApp';

export const useSMGetDraftedApp = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getDraftedAppMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(getDraftedAppMachine);

  // useEffect(() => {
  //   send({ type: 'START' });
  // }, []);

  return {
    getDraftedAppMachine,
    getDraftedAppState: state,
    getDraftedAppSend: send,
  };
};
